export const CashCalculatorIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <path d="M23.5,13.5v8a2,2,0,0,1-2,2h-7a2.006,2.006,0,0,1-2-2v-8Z" fill="#c4f0eb" />
      <path
        d="M21.5,21.5h-7a2.006,2.006,0,0,1-2-2v2a2.006,2.006,0,0,0,2,2h7a2,2,0,0,0,2-2v-2A2,2,0,0,1,21.5,21.5Z"
        fill="#00e6ca"
      />
      <path
        d="M23.5,13.5v8a2,2,0,0,1-2,2h-7a2.006,2.006,0,0,1-2-2v-8Z"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5,10.5H1.5a1,1,0,0,1-1-1v-8a1,1,0,0,1,1-1h16a1,1,0,0,1,1,1l0,8A1,1,0,0,1,17.5,10.5Z"
        fill="#00e6ca"
      />
      <path
        d="M17.5,10.5H1.5a1,1,0,0,1-1-1v2a1,1,0,0,0,1,1h16a1,1,0,0,0,1-1V9.531A1,1,0,0,1,17.5,10.5Z"
        fill="#c4f0eb"
      />
      <path d="M17.5,12.5H1.5v1a1,1,0,0,0,1,1h14a1,1,0,0,0,1-1v-1Z" fill="#c4f0eb" />
      <path d="M1.5.5a1,1,0,0,0-1,1v8a1,1,0,0,0,.2.6L10.3.5Z" fill="#c4f0eb" />
      <path
        d="M10.5,10.5h-9a1,1,0,0,1-1-1v-8a1,1,0,0,1,1-1h16a1,1,0,0,1,1,1v5"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M.5,4,4,.5" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18.5,4,15,.5" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M.5,7,4,10.5" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M11.5,3.5H8.346a.843.843,0,0,0-.2,1.66l2.724.68a.843.843,0,0,1-.2,1.66H7.5"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9.5,3.5v-1" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.5,8.5v-1" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5,15.5h1" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.5,15.5h1" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20.5,15.5h1" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5,17.5h1" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.5,17.5h1" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20.5,17.5h1" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5,19.5h1" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.5,19.5h1" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20.5,19.5h1" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5,21.5h1" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.5,21.5h1" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20.5,21.5h1" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M23.5,10.5v3h-11v-3a2.006,2.006,0,0,1,2-2h7A2,2,0,0,1,23.5,10.5Z" fill="#00e6ca" />
      <path d="M12.5,10.5v3h2.124l5-5H14.5A2.006,2.006,0,0,0,12.5,10.5Z" fill="#c4f0eb" />
      <path
        d="M23.5,10.5v3h-11v-3a2.006,2.006,0,0,1,2-2h7A2,2,0,0,1,23.5,10.5Z"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1.5,12.5h9" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.5,14.5h8" fill="none" stroke="#0f172a" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
